module.exports = __webpack_public_path__ + "img/graydelete.94396b76.svg";